export default __webpack_public_path__ + "static/media/toggleArrow.c379147d.svg";